import { lazy } from "react";
import { MedicalRecordRoute } from "./routes/medicalRecordRoute";

const ComponentForgotPassword = lazy(() => import("./components/ComponentForgotPassword"));
const ComponentInvoice = lazy(() => import("./components/ComponentInvoice"));
const ComponentMutation = lazy(() => import("./components/ComponentMutation"));
const ComponentTopup = lazy(() => import("./components/ComponentTopup"));
const CreatePassword = lazy(() => import("./components/createPasswordComponent"));
const Home = lazy(() => import("./components/homeComponent"));
const Info = lazy(() => import("./components/infoComponent"));
const InfoDetailMobile = lazy(() => import("./components/infoComponent/infoDetailMobile"));
const Login = lazy(() => import("./components/loginComponent"));
const Profile = lazy(() => import("./components/profileComponent"));

const Inbox = lazy(() => import("./components/inboxComponent"));
const AccountComponent = lazy(() => import("./components/accountComponent"));
const CardComponent = lazy(() => import("./components/cardComponent"));

const ScheduleComponent = lazy(() => import("./components/scheduleComponent"));
const CalendarComponent = lazy(() => import("./components/calendarComponent"));
const ComponentTopupHistory = lazy(() => import("./components/ComponentTopupHistory"));
const ComponentTransactionHistory = lazy(() => import("./components/ComponentTransactionHistory"));
const ComponentTransactionDetailHistory = lazy(() => import("./components/ComponentTransactionDetailHistory"));
const ComponentAttendance = lazy(() => import("./components/ComponentAttendance"));
const ComponentAttendanceDetail = lazy(() => import("./components/ComponentAttendanceDetail"));
const ComponentDonation = lazy(() => import("./components/ComponentDonation"));
const ComponentDonationDetail = lazy(() => import("./components/ComponentDonationDetail"));
const ComponentEditProfile = lazy(() => import("./components/ComponentEditProfile"));
const ComponentAutoLogin = lazy(() => import("./components/ComponentAutoLogin"));
const ComponentChangePassword = lazy(() => import("./components/ComponentChangePassword"));
const ComponentFAQ = lazy(() => import("./components/ComponentFAQ"));
const ComponentChangeLanguage = lazy(() => import("./components/ComponentChangeLanguage"));
const ComponentTopupTutorial = lazy(() => import("./components/ComponentTopupTutorial"));
const ComponentForgotPasswordConfirmation = lazy(() => import("./components/ComponentForgotPasswordConfirmation"));
const ComponentForgotPasswordOTP = lazy(() => import("./components/ComponentForgotPasswordOTP"));
const ComponentForgotPasswordCreate = lazy(() => import("./components/ComponentForgotPasswordCreate"));
const ConfirmationData = lazy(() => import("./components/confirmationDataComponent"));
const ConfirmationDataIntro = lazy(() => import("./components/confirmationDataIntroComponent"));
const BurekolComponent = lazy(() => import("./components/burekolComponent"));

const SyncHistoryComponent = lazy(() => import("./components/cardComponent/syncHistory"));
const ComponentInactiveError = lazy(() => import("./components/ComponentInactiveError"));
const PickupStudent = lazy(() => import("./components/pickupStudentComponent"));
const PickupStudentInstant = lazy(() => import("./components/pickupStudentComponent/pickupStudentInstant"));
const ScanPickupStudent = lazy(() => import("./components/pickupStudentScanComponent"));
const CreateQRPickupStudent = lazy(() => import("./components/pickupStudentCreateQRComponent"));
const BookingPickupStudent = lazy(() => import("./components/pickupStudentBookingComponent"));
const StatusBookingPickupStudent = lazy(() => import("./components/pickupStudentStatusComponent"));
const StatusBookingDetailPickupStudent = lazy(() => import("./components/pickupStudentStatusDetailComponent"));
const ComponentAttendancePro = lazy(() => import("./components/ComponentAttendancePro"));
const ComponentSupport = lazy(() => import("./components/ComponentSupport"));
const ViolationPoint = lazy(() => import("./components/violationPointComponent"));
const ViolationPointReward = lazy(() => import("./components/violationPointRewardComponent"));
const ViolationPointViolation = lazy(() => import("./components/violationPointViolationComponent"));
const ViolationPointForm = lazy(() => import("./components/violationPointFormComponent"));
const ComponentInvoiceDetail = lazy(() => import("./components/ComponentInvoiceDetail"));
const ComponentInvoiceCreditPayment = lazy(() => import("./components/ComponentInvoiceCreditPayment"));
const ViolationPointRewardDetailComponent = lazy(() => import("./components/violationPointRewardDetailComponent"));
const ViolationPointViolationDetailComponent = lazy(() => import("./components/violationPointViolationDetailComponent"));
const Journal = lazy(() => import("./components/journalComponent"));
const JournalDetail = lazy(() => import("./components/journalDetailComponent"));
const RecitationSubmission = lazy(() => import("./components/recitationSubmissionComponent"));
const RecitationSubmissionReport = lazy(() => import("./components/recitationSubmissionReportComponent").then((module) => ({ default: module.RecitationSubmissionReport })));
const RecitationDetail = lazy(() => import("./components/recitationDetail"));

const Saving = lazy(() => import("./components/savingComponent"));
const SavingCreate = lazy(() => import("./components/savingCreateComponent"));
const ReceiptMobile = lazy(() => import("./components/savingComponent/receiptMobile"));
const PerizinanMobile = lazy(() => import("./components/perizinanComponent/perizinanMobile"));
const FormMobile = lazy(() => import("./components/perizinanComponent/formMobile"));
const DetailPerizinanMobile = lazy(() => import("./components/perizinanComponent/detailPerizinanMobile"));
const ComponentInvoiceHistoryDetail = lazy(() => import("./components/ComponentInvoice/historyDetailComponent"));
import { ConfirmationVerify } from "./components/confirmationVerifyComponents";
import { ConfirmationVerifyOTP } from "./components/confirmationVerifyOTP";
import { LoginSelectAccount } from "./components/loginSelectAccount";

const Routes: any = [
  {
    path: "",
    redirect: "Home",
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "login",
    component: Login,
  },
  {
    path: "login/select-account",
    component: LoginSelectAccount,
  },
  {
    path: "confirmation-data",
    component: ConfirmationData,
  },
  {
    path: "confirmation-data/intro",
    component: ConfirmationDataIntro,
  },
  {
    path: "confirmation-data/verify",
    component: ConfirmationVerify,
  },
  {
    path: "confirmation-data/verify/otp",
    component: ConfirmationVerifyOTP,
  },
  {
    path: "create-password",
    component: CreatePassword,
  },
  {
    path: "forgot-password",
    component: ComponentForgotPassword,
  },
  {
    path: "forgot-password-confirmation",
    component: ComponentForgotPasswordConfirmation,
  },
  {
    path: "forgot-password-otp",
    component: ComponentForgotPasswordOTP,
  },
  {
    path: "forgot-password-create",
    component: ComponentForgotPasswordCreate,
  },
  {
    path: "profile",
    component: Profile,
  },
  {
    path: "edit-profile",
    component: ComponentEditProfile,
  },
  {
    path: "topup",
    component: ComponentTopup,
  },
  {
    path: "topup-history",
    component: ComponentTopupHistory,
  },
  {
    path: "/info",
    component: Info,
  },
  {
    path: "/info-detail/:id",
    component: InfoDetailMobile,
  },
  {
    path: "/message",
    component: Inbox,
  },
  {
    path: "account",
    component: AccountComponent,
  },
  {
    path: "digital-card",
    component: CardComponent,
  },
  {
    path: "digital-card/:id/",
    component: SyncHistoryComponent,
  },
  {
    path: "schedule",
    component: ScheduleComponent,
  },
  {
    path: "calendar",
    component: CalendarComponent,
  },
  {
    path: "invoice",
    component: ComponentInvoice,
  },

  {
    path: "invoicedetail/:id",
    component: ComponentInvoiceDetail,
  },
  {
    path: "invoice/history/detail",
    component: ComponentInvoiceHistoryDetail,
  },
  {
    path: "invoice-credit-payment",
    component: ComponentInvoiceCreditPayment,
  },
  // {
  //   path: "invoice-v2",
  //   component: ComponentInvoiceV2,
  // },
  // {
  //   path: "invoicedetail-v2/:id",
  //   component: ComponentInvoiceDetailV2,
  // },
  // {
  //   path: "invoice-credit-payment-v2",
  //   component: ComponentInvoiceCreditPaymentV2,
  // },
  {
    path: "mutation",
    component: ComponentMutation,
  },
  {
    path: "transaction-history",
    component: ComponentTransactionHistory,
  },
  {
    path: "transaction-detail",
    component: ComponentTransactionDetailHistory,
  },
  {
    path: "attendance",
    component: ComponentAttendance,
  },
  {
    path: "attendance-detail",
    component: ComponentAttendanceDetail,
  },
  {
    path: "donation",
    component: ComponentDonation,
  },
  {
    path: "donation-detail",
    component: ComponentDonationDetail,
  },
  {
    path: "auto-login",
    component: ComponentAutoLogin,
  },
  {
    path: "change-password",
    component: ComponentChangePassword,
  },
  {
    path: "faq",
    component: ComponentFAQ,
  },
  {
    path: "burekol",
    component: BurekolComponent,
  },
  {
    path: "burekol/:bankName",
    component: BurekolComponent,
  },
  {
    path: "change-language",
    component: ComponentChangeLanguage,
  },
  {
    path: "topup-tutorial",
    component: ComponentTopupTutorial,
  },
  {
    path: "inactive/:name/:error",
    component: ComponentInactiveError,
  },
  {
    path: "pickup-student",
    component: PickupStudent,
  },
  {
    path: "pickup-student/scan/:studentId/:grade",
    component: ScanPickupStudent,
  },
  {
    path: "pickup-student/create-qr/:studentId/:grade/:studentName",
    component: CreateQRPickupStudent,
  },
  {
    path: "pickup-student/booking",
    component: BookingPickupStudent,
  },
  {
    path: "pickup-student/instant",
    component: PickupStudentInstant,
  },
  {
    path: "pickup-student/status",
    component: StatusBookingPickupStudent,
  },
  {
    path: "pickup-student/status/:id",
    component: StatusBookingDetailPickupStudent,
  },
  { path: "/attendance-pro", component: ComponentAttendancePro },
  {
    path: "/point-guard",
    component: ViolationPoint,
  },
  {
    path: "/point-guard/reward",
    component: ViolationPointReward,
  },
  {
    path: "/point-guard/violation",
    component: ViolationPointViolation,
  },
  {
    path: "/point-guard/reward/create",
    component: ViolationPointForm,
  },
  {
    path: "/point-guard/reward/:id",
    component: ViolationPointRewardDetailComponent,
  },
  {
    path: "/point-guard/violation/:id",
    component: ViolationPointViolationDetailComponent,
  },
  { path: "etc", component: ComponentSupport },
  {
    path: "setoran-hafalan",
    component: RecitationSubmission,
  },
  {
    path: "setoran-hafalan/report",
    component: RecitationSubmissionReport,
  },
  {
    path: "setoran-hafalan/detail",
    component: RecitationDetail,
  },
  {
    path: "journal",
    component: Journal,
  },
  {
    path: "journal/detail/:id",
    component: JournalDetail,
  },
  {
    path: "/journal/:token/:lang",
    component: Journal,
  },
  {
    path: "saving",
    component: Saving,
  },
  {
    path: "saving/mutation/:id",
    component: ReceiptMobile,
  },
  {
    path: "saving/mutation",
    component: ReceiptMobile,
  },
  {
    path: "saving/create",
    component: SavingCreate,
  },
  {
    path: "perizinan",
    component: PerizinanMobile,
  },
  {
    path: "perizinan/form",
    component: FormMobile,
  },
  {
    path: "perizinan/:id/detail",
    component: DetailPerizinanMobile,
  },
  ...MedicalRecordRoute,
];
export default Routes;
